import { isNull } from "lodash"
import { useTranslation } from "react-i18next"

import BasicButton from "@/components/button/BasicButton"
import Dialog from "@/components/dialog/Dialog"

export default function DeleteItemDialog({
  deleteItemIndex,
  setDeleteItemIndex,
  onDeleteAction,
}: {
  deleteItemIndex: number | null
  setDeleteItemIndex: (index: number | null) => void
  onDeleteAction: (index: number) => void
}) {
  const { t } = useTranslation()

  return (
    <Dialog
      open={!isNull(deleteItemIndex)}
      maxWidth="400px"
      title={t("confirm")}
      onClose={() => setDeleteItemIndex(null)}
      footer={
        <>
          <BasicButton type="default-outlined" size="md" onClick={() => setDeleteItemIndex(null)}>
            {t("button.cancel")}
          </BasicButton>
          <BasicButton
            type="danger-outlined"
            size="md"
            onClick={() => {
              onDeleteAction(deleteItemIndex as number)
              setDeleteItemIndex(null)
            }}>
            {t("button.delete")}
          </BasicButton>
        </>
      }>
      <p>{t("messages.confirmDelete")}</p>
    </Dialog>
  )
}
